import React, { useEffect, useState } from 'react';
import { Card } from '@mlc/web-ui-toolkit';
import LoadingIndicator from '../../../../common/LoadingIndicator';
import { PlanMemberDemographics as MemberDemographicsDomain } from '../../../../../logic/domains/planProfile.domain';
import { getPlanMemberDemographics } from '../../../../../logic/functions/planProfile.function';
import ApiError from '../../../Error/ApiError';
import NoData from '../Common/NoData';
import { asFormattedDate } from '../../../../common/formatter';
import Note from './MemberDemographics/Note';
import InvestorMovement from './MemberDemographics/InvestorMovement';
import BenefitGroups from './MemberDemographics/BenefitGroups';
import AvgInvestorBalance from './MemberDemographics/AvgInvestorBalance';
import Tab from '../Common/Tab';
import { MainContent } from './MemberDemographics/StaticContent';

interface Props {
	asAtDate: string;
	planUUID: string;
	totalInvestors: number;
}

const MemberDemographics: React.FunctionComponent<Props> = props => {
	const [memberDemographics, setMemberDemographics] = useState<
		MemberDemographicsDomain | undefined
	>();
	const [isLoading, setIsLoading] = useState(true);

	const formattedDate = asFormattedDate(props.asAtDate);

	useEffect(() => {
		const fetchData = async () => {
			setMemberDemographics(await getPlanMemberDemographics(props.planUUID));
			setIsLoading(false);
		};
		fetchData();
	}, []);

	if (isLoading) {
		return <LoadingIndicator />;
	}

	if (!memberDemographics) {
		return <ApiError />;
	}
	if (props.totalInvestors <= 0) {
		return <NoData />;
	}

	return (
		<Tab title={MainContent.heading}>
			<React.Fragment>
				<Note />
				<Card marginTop={5}>
					<InvestorMovement
						asAtDate={formattedDate}
						investorMovement={memberDemographics.investorMovement}
					/>
				</Card>
				<Card marginTop={8}>
					<BenefitGroups planCategories={memberDemographics.planCategories} />
				</Card>
				<Card marginTop={8}>
					<AvgInvestorBalance
						asAtDate={formattedDate}
						averageInvestorBalance={memberDemographics.averageInvestorBalance}
					/>
				</Card>
			</React.Fragment>
		</Tab>
	);
};

export default MemberDemographics;
